const [d, l] = [document, location]

export default function CURRENT_NAV(q = '[data-plugin="currentNav"]') {

  const pathname = l.pathname;
  const search =  l.search.toLowerCase();

  const init = () => {
    const containers = d.querySelectorAll(q);
    containers.forEach(container => {

      const links = container.querySelectorAll('a');

      links.forEach(link => {
        scan(link);
      })
    })
  }

  const scan = link => {
    const linkHref = link.getAttribute('href');
    if (linkHref == pathname + search) {
      link.classList.add('current');
    }

    if (search == '' && link.classList.contains('all')) {
      link.classList.add('current');
    }
  }

  init();

  d.addEventListener('DOMContentLoaded', init);
}